var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoyaltyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 91.452 91.261",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.204 37.517a8.745 8.745 0 017.857 4.926.682.682 0 001.2.041l9.649-16.712a.707.707 0 00-.265-.957 77.157 77.157 0 00-75.887 0 .715.715 0 00-.265.957l37.6 65.139a.689.689 0 001.2 0L66.487 55.98a.692.692 0 00-.652-1.04 8.17 8.17 0 01-3.7-.59 8.876 8.876 0 01-5.639-7.939 8.724 8.724 0 018.708-8.894zM28.197 38.86l-2.468-2.463c-3.237-3.237-2.158-9.14 3.2-10.605a5.39 5.39 0 015.211 1.425l2.361 2.341a.7.7 0 00.977 0l2.341-2.341a5.39 5.39 0 015.21-1.425c5.374 1.466 6.433 7.369 3.2 10.605l-10.77 10.768a.7.7 0 01-.977 0zm17.527 33.221a8.733 8.733 0 118.733-8.733 8.744 8.744 0 01-8.734 8.733z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.12 19.888a.672.672 0 00.936.244 82.6 82.6 0 0181.343 0 .69.69 0 00.936-.244l4.03-6.982a.707.707 0 00-.265-.957 92.054 92.054 0 00-90.747.02.715.715 0 00-.265.957z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoyaltyIcon);
export default __webpack_public_path__ + "static/media/loyalty_icon.312ced54fc394544197a4dc3b02b1876.svg";
export { ForwardRef as ReactComponent };